module.exports = __webpack_public_path__ + "static/img/sfz_btn.e89630eb.png";